import React, { useEffect, useState } from "react";
import { Box, Skeleton, useMediaQuery, useTheme } from "@mui/material";
import {
  useLocation,
  useNavigate,
  // useParams,
  useSearchParams,
} from "react-router-dom";
import ProductFilters from "./ProductFilters";
import ProductGrid from "./ProductGrid";
import useFetch from "../../hooks/useFetch";
import { motion } from "framer-motion";
import { AppBar, Toolbar, Typography, InputBase, Paper } from "@mui/material";
import Image from "../../components/Image";
import NoImage from "../../Assests/placeholder.jpg";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import {
  Brand_url_top_global,
  Brand_url_new_global,
  Filter_url,
  Produts_Add,
} from "../../api/urls";
import NoProductsAvailable from "../../components/NoProductsAvailable";
import { useFetchWithPagination } from "../../hooks/useFetchWithPagination";

const StyledInputBase = styled(InputBase)(() => ({
  flex: 1,
  input: {
    padding: 0,
    height: "100%",
    fontSize: "0.95rem",
  },
}));
const Search = styled(Box)(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#f5f5f5",
  width: "100%",
  maxWidth: "300px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1),
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: theme.spacing(1),
  color: "rgba(0, 0, 0, 0.54)",
}));
const AllProducts = () => {
  // const [filter, setFilters] = useState([]);
  // const [products, setProducts] = useState([]);
  const { data: newBrands, loading: newBrandLoading } =
    useFetch(Brand_url_new_global);
  // const [banner, setBanner] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  // const [loading, setLoading] = useState(true);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location?.pathname;

  const [selectedProperties, setSelectedProperties] = useState([]); //this is what i aadded
  const isGlobalStore = currentPath === "/global_store";
  // const isB2BStore = currentPath === "/b2b_store";

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };
  const { data: topBrands, loading: topBrandLoading } =
    useFetch(Brand_url_top_global);
  const handleSearchChange = (e) => setSearchQuery(e.target.value);
  const [searchParams] = useSearchParams();
  // const third_category = location?.state?.catID;
  const third_category = searchParams.get("third_category");
  const brand = searchParams.get("brand");
  const categoryName = location?.state?.name; //
  // console.log(third_category,"third_category");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const handleFilterChange = (category, itemCode, checked) => {
    setSelectedProperties((prev) => {
      if (checked) {
        // Add the property ID
        return [...prev, itemCode];
      } else {
        // Remove the property ID
        return prev.filter((id) => id !== itemCode);
      }
    });
  };
  const navigateToBrandProducts = (catID) => {
    navigate(`/products`, { state: { catID } });
  };

  const renderBrandGrid = (list) =>
    list?.map((brand, index) => (
      <motion.div
        key={brand.id || index}
        whileHover={{ scale: 1.05 }}
        style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
        onClick={() => navigateToBrandProducts(brand?.brand_name)}
      >
        <Paper
          elevation={0}
          sx={{
            p: 2,
            border: "1px solid #eee",
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <Image
            src={brand?.brand_image_upload || NoImage}
            alt={brand?.brand_name || `Brand ${index + 1}`}
            loading="lazy"
            style={{ width: "250px", height: "200px", objectFit: "contain" }}
          />
        </Paper>
      </motion.div>
    ));
  // const { data: banner, loading: bannerLoading } = useFetch(Mens_adv_url);

  // const bizValue =
  //   currentPath === "/global_store"
  //     ? "store=is_global&"
  //     : currentPath === "/b2b_store"
  //       ? "biz=is_b2b&"
  //       : "";
  // const {
  //   data,
  //   pagination,
  //   loading: productsLoading,
  // } = useFetchWithPagination(
  //   Produts_Add +
  //     `${bizValue ? `?${bizValue}` : ""}${searchQuery ? `&search=${searchQuery}` : ""}${
  //       third_category ? `&third_category=${third_category}` : ""
  //     }${
  //       brand ? `&brand=${brand}` : ""
  //     }${selectedProperties?.length > 0 ? `&properties=${selectedProperties?.join(",")}` : ""}`,
  // );

  const params = new URLSearchParams();

  if (currentPath === "/global_store") {
    params.append("store", "is_global");
  }

  if (currentPath === "/b2b_store") {
    params.append("biz", "is_b2b");
  }

  if (searchQuery) {
    params.append("search", searchQuery);
  }

  if (third_category) {
    params.append("third_category", third_category);
  }

  if (brand) {
    params.append("brand", brand);
  }

  if (selectedProperties?.length > 0) {
    params.append("properties", selectedProperties.join(","));
  }

  const {
    data,
    pagination,
    loading: productsLoading,
  } = useFetchWithPagination(`${Produts_Add}?${params.toString()}`);

  const products = data?.results;
  // console.log(data);
  // console.log(products);

  const { data: filter } = useFetch(
    third_category && `${Filter_url}?cat_id=${third_category}&cat_type=3`,
  );
  // console.log(filter, "filter");
  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true);
      try {
        // No separate global search API now
        // Always use ProductAdd with `search=` included

        const params = new URLSearchParams();

        if (third_category) params.append("third_category", third_category);

        if (searchQuery && searchQuery.trim() !== "")
          params.append("search", searchQuery.trim());

        if (selectedProperties?.length > 0)
          params.append("properties", selectedProperties.join(","));

        // const [filtersRes] = await Promise.all([
        //   // api.get(finalURL),
        //   third_category
        //     ? api.get(`${Filter_url}?cat_id=${third_category}&cat_type=3`)
        //     : Promise.resolve({ data: [] }),
        // ]);

        // // setProducts(productsRes.data?.results || []);
        // setFilters(filtersRes.data);
        // console.log(productsRes,"i am res")
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, [third_category, selectedProperties, currentPath, searchQuery]);

  // const handlePageChange = (event, value) => {
  //   setCurrentPage(value);
  // };
  // if (bannerLoading) {
  //   return <Loading />;
  // }
  return (
    <>
      {/* {banner?.[1]?.ad_image && (
        <Box sx={{ cursor: "pointer" }}>
          <img
            src={banner?.[1]?.ad_image}
            alt="Sales Banner"
            style={{ width: "100%", objectFit: "cover", height: "50vh" }}
          />
        </Box>
      )} */}
      {categoryName && (
        <h2 style={{ padding: "20px", fontSize: "24px", fontWeight: "bold" }}>
          Products for {categoryName}
        </h2>
      )}
      {/* Premium Brands – only for Global Store */}
      {isGlobalStore && (
        <Box px={2} py={3}>
          <motion.div initial="hidden" animate="visible" variants={fadeIn}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={5}
              sx={{ textAlign: "left" }}
            >
              <Typography
                sx={{
                  flexGrow: 1,
                  marginLeft: 2,
                  marginTop: 2,
                  marginBottom: 2,
                  display: { sm: "block" },
                  fontSize: "20px",
                }}
              >
                Premium Brands
              </Typography>
            </Box>
            {newBrandLoading ? (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  p: 2,
                  width: "100%",
                  margin: "auto",
                  justifyContent: { xs: "center", md: "start" },
                }}
              >
                <Skeleton height={300} width={300} />
                <Skeleton height={300} width={300} />
              </Box>
            ) : (
              <Box
                display="grid"
                gridTemplateColumns={{
                  xs: "repeat(1, 1fr)",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(3, 1fr)",
                  lg: "repeat(4, 1fr)",
                }}
                gap={2}
              >
                {renderBrandGrid(newBrands?.slice(0, 8))}
              </Box>
            )}
          </motion.div>
        </Box>
      )}

      {/* Top Brands – only for Global Store */}
      {isGlobalStore && (
        <Box px={2} py={3}>
          <motion.div initial="hidden" animate="visible" variants={fadeIn}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              // mb={5}
              sx={{ textAlign: "left" }}
            >
              <Typography
                sx={{
                  flexGrow: 1,
                  marginLeft: 2,
                  marginTop: 2,
                  marginBottom: 2,
                  display: { sm: "block" },
                  fontSize: "20px",
                }}
              >
                Top Brands
              </Typography>
              {topBrands?.length > 8 && (
                <Typography
                  variant="body2"
                  sx={{
                    cursor: "pointer",
                    color: "#00000080",
                    userSelect: "none",
                    fontSize: "16px",
                  }}
                  onClick={() => navigate("/top_brand")}
                >
                  See All
                </Typography>
              )}
            </Box>
            {topBrandLoading ? (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  p: 2,
                  width: "100%",
                  margin: "auto",
                  justifyContent: { xs: "center", md: "start" },
                }}
              >
                <Skeleton height={300} width={300} />
                <Skeleton height={300} width={300} />
              </Box>
            ) : (
              <Box
                display="grid"
                gridTemplateColumns={{
                  xs: "repeat(1, 1fr)",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(3, 1fr)",
                  lg: "repeat(4, 1fr)",
                }}
                gap={2}
              >
                {renderBrandGrid(topBrands?.slice(0, 8))}
              </Box>
            )}
          </motion.div>
        </Box>
      )}

      {/* Global Search bar – only for Global Store */}
      {isGlobalStore && (
        <AppBar
          position="static"
          sx={{
            backgroundColor: "transparent",
            color: "black",
            boxShadow: "none",
          }}
        >
          <Toolbar sx={{ gap: 1 }}>
            <Typography
              variant="h6"
              sx={{ flexGrow: 1, display: { sm: "block" }, marginLeft: "10px" }}
            >
              Explore Global Products
            </Typography>
            <Box
              display="flex"
              // alignItems="center"
              gap={2}
              position="relative"
              marginTop={2}
            >
              <Box position="relative">
                <Search>
                  <StyledInputBase
                    placeholder="Search global products"
                    inputProps={{ "aria-label": "search" }}
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                </Search>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      )}
      <Box
        sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
        className={"mb-5"}
      >
        {
          <>
            <ProductFilters
              filters={filter || []}
              isMobile={isMobile}
              mobileFiltersOpen={mobileFiltersOpen}
              setMobileFiltersOpen={setMobileFiltersOpen}
              onFilterChange={handleFilterChange}
              selectedProperties={selectedProperties}
            />
            {productsLoading ? (
              <div className="mens-content justify-center p-5">
                <div className="mens-products justify-center">
                  {Array.from({ length: 18 }).map((_, index) => (
                    <SkeletonCard key={index} />
                  ))}
                </div>
              </div>
            ) : products?.length === 0 ? (
              <div className="flex justify-center items-center w-screen">
                <NoProductsAvailable />
              </div>
            ) : (
              <ProductGrid
                products={products}
                // currentPage={currentPage}
                // productsPerPage={productsPerPage}
                // handlePageChange={handlePageChange}
                // pagination={pagination}
              />
            )}
          </>
        }
      </Box>
      <Box sx={{ maxWidth: "300px", mx: "auto" }}>
        {products && products?.length > 0 && pagination}
      </Box>
      {/* {!productsLoading && products?.length === 0 && <NoProductsAvailable />} */}
    </>
  );
};

export default AllProducts;

export const SkeletonCard = () => (
  <div className="mb-5 md:mx-2">
    {/* Image placeholder */}
    <div className="w-[135px] sm:w-35 md:w-45 lg:w-60 h-40 md:h-50 lg:h-60 bg-gray-300 animate-pulse rounded-md" />
    {/* Text placeholders */}
    <div className="mt-2 space-y-2">
      <div className="h-5 w-3/5 bg-gray-300 animate-pulse rounded" />
      <div className="h-5 w-4/5 bg-gray-300 animate-pulse rounded" />
      {/* <div className="h-5 w-2/5 bg-gray-300 animate-pulse rounded" />
      <div className="h-4 w-1/2 bg-gray-300 animate-pulse rounded" /> */}
    </div>
  </div>
);
